module.exports = __webpack_public_path__ + "img/icon_map_4_off_100.3fb95bb8.png";